const { buildConfigGetter } = require('../configBuilder');

module.exports = buildConfigGetter('segment', {
  envOptions: true,
});
